import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239681b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["is-active", "aria-label"]
const _hoisted_2 = { class: "material-icons" }




export default /*#__PURE__*/_defineComponent({
  props: {
    icon: String, //expects icon from https://fonts.google.com/icons?selected=Material+Icons
    active: {
        type: Boolean,
        default: false
    },
    label : String
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn",
    "is-active": __props.active,
    "aria-label": __props.label
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.icon), 1)
  ], 8, _hoisted_1))
}
}

})